import * as React from 'react';

import { CardSectionNew } from 'shared/components/CardSectionNew';

import { trackSubscribed, trackSubscriptionModalClose, trackSubscriptionModalOpen } from './tracking';
import { useSearchSetParams } from './useSearchSetParams';
import { SaveSearchContainer, TOnSubmitSaveSearchParams, useSaveSearchEvents } from '../../../packages/SaveSearchModal';
import { LocationSubscription } from '../../components/LocationSubscription';

export const LocationSubscriptionContainer = () => {
  const { handleClick, offerId } = useSearchSetParams();

  const handleOnSubscribed = React.useCallback(
    (parameters: TOnSubmitSaveSearchParams) => {
      trackSubscribed({
        frequency: parameters.frequency,
        subscribeToNews: parameters.subscribeToNews,
        title: parameters.title,
        email: parameters.email,
        defaultTitle: parameters.defaultTitle,
        defaultEmail: parameters.defaultEmail,
        offerId,
      });

      /* istanbul ignore next */
      if (window.__reloadHeader__) {
        window.__reloadHeader__();
      }
    },
    [offerId],
  );

  useSaveSearchEvents(handleOnSubscribed, trackSubscriptionModalOpen, trackSubscriptionModalClose);

  return (
    <CardSectionNew hideForPrint withBorders>
      <LocationSubscription onClick={handleClick} />
      <SaveSearchContainer />
    </CardSectionNew>
  );
};
